import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-50f8a286"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "DailyInspection"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "data-detail"
};
var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-50f8a286><div class=\"item\" data-v-50f8a286>巡检点名称</div><div class=\"item\" data-v-50f8a286>巡检点编码</div><div class=\"item\" data-v-50f8a286>是否巡检</div><div class=\"item\" data-v-50f8a286>巡检员</div></div>", 1);
var _hoisted_5 = {
  class: "item"
};
var _hoisted_6 = {
  class: "item"
};
var _hoisted_7 = {
  class: "item"
};
var _hoisted_8 = {
  class: "item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_title = _resolveComponent("c-title");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "巡检看板-详情"
  }), _createElementVNode("div", _hoisted_3, [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "row",
      key: item.id
    }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.card_no), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.has_patrol ? '是' : '否'), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.person_name ? item.person_name : '-'), 1)]);
  }), 128))])])]);
}